import { WebSocketService } from './WebSocketService';
import Config from '@/config';
import { EngineService } from '@/services/engine/engine-service';

function buildWsUrl(): string {
    const baseHttpUrl = Config.VITE_ENGINE_URL || 'http://localhost';

    if (
        !baseHttpUrl.startsWith('http://') &&
        !baseHttpUrl.startsWith('https://')
    ) {
        return `ws://${baseHttpUrl}/notifications/ws`;
    }
    // Replace http(s) with ws(s)
    const wsBase = baseHttpUrl.replace(/^https/, 'wss').replace(/^http/, 'ws');
    return `${wsBase}/notifications/ws`;
}

export const webSocketService = new WebSocketService({
    get url() {
        return buildWsUrl();
    },
    reconnect: {
        initialDelay: 3000,
        maxDelay: 30000,
        backoffMultiplier: 2,
    },
    heartbeat: {
        interval: 30000,
    },
    beforeReconnect: () => EngineService.checkAuth(),
});

export { WebSocketService, WSMessageType } from './WebSocketService';
